function processTreeLevel (choices, filterFn, searchText, componentRef, childKey, preserveParentNode) {
  return choices.map(_item => {
    const item = {..._item};
    const isParent = item[childKey] && item[childKey].length > 0;

    // filter current node if is leaf or parent (with enabled preserveParentNode)
    if (isParent && preserveParentNode || !isParent) {
      if (filterFn(item, searchText, componentRef)) {
        return item;
      }
    }

    if (isParent) {
      const nodeChildren = item[childKey];
      const filteredChild = processTreeLevel(
        nodeChildren, filterFn, searchText, componentRef, childKey, preserveParentNode
      );

      if (filteredChild && filteredChild.length > 0) {
        item[childKey] = filteredChild;

        return item;
      }
    }


    return null;
  }).filter(i => Boolean(i)); // filter empty elements
}


/**
 * filter choices structure with filter function
 * @param {Array} choices - array of choices (child nodes are array in parent node object)
 * @param {function} filterFn - function that filters choices, takes [item to check, search text,
 * reference to Vue component]
 * @param {String} searchText - text to search in choice node
 * @param {vNode} componentRef - reference to Vue component (required if needed in search function)
 * @param {String} childKey - choice object key where children array is stored
 * @param {Boolean} preserveParentNode - filter by parent node name
 * @returns {Array} - array of filtered choices
 */
export default function filterChoicesTree (choices, filterFn, searchText, componentRef,
  childKey = 'children', preserveParentNode = false) {

  return processTreeLevel(choices, filterFn, searchText, componentRef, childKey, preserveParentNode);
}
